<template>
  <div class="page_entrySign">
    <div class="eleForm" v-loading="isdistinguish" element-loading-text="识别中">
      <el-form :model="dtlForm" :inline="true" :rules="signType=='entry' ?  entryRules : InterViewrules" ref="signForm" label-width="120px">
        <el-form-item label="项目名称" prop="StrEmpName">
          <el-select v-model="dtlForm.projectid" filterable clearable size="small" placeholder="" style="width:300px" @change="changePro">
            <el-option v-for="(item, index) in resProjectList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="岗位名称">
          <el-select v-model="dtlForm.jobid" filterable clearable style="width:300px" size="small" placeholder="请选择岗位">
            <el-option v-for="(item, index) in searPostList" :key="index" :label="item.CustomerJobName" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名" prop="StrEmpName">
          <el-input v-model="dtlForm.StrEmpName" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="StrPhoneNum">
          <el-input v-model="dtlForm.StrPhoneNum" @blur="checkPhone(dtlForm.StrPhoneNum)" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="身份证号码" prop="StrIdCard">
          <input id="upload_file" type="file" style="display: none;" accept='image/*' name="file" @change="fileChange($event)" />
          <el-input v-model="dtlForm.StrIdCard" @blur="checkIdcard" style="width:300px" size="small">
            <el-button slot="append" title="识别图片" icon="el-icon-picture-outline" @click="distinguish('#upload_file')" v-if="signType == 'entry'"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-input v-model="sex" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="出生年月">
          <el-input v-model="birth" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="年龄">
          <el-input v-model="age" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="面试时间" v-if="signType == 'interView'">
          <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="dtlForm.Dtfacetime" type="date" placeholder="" style="width: 300px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="民族" prop="StrNationClass">
          <el-input v-model="dtlForm.StrNationClass" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="户籍地址" prop="StrNativeAddr">
          <el-input v-model="dtlForm.StrNativeAddr" placeholder="详细地址（例如**省**市**街**号）" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="政治面貌" prop="StrPolitical">
          <el-select v-model="dtlForm.StrPolitical" placeholder="" style="width:300px" size="small" clearable>
            <el-option v-for="(item,index) in politicalList" :key="index" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="身份证有效终止时间" prop="DtIcCareEdate">
          <div class="flex">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="dtlForm.DtIcCareEdate" :disabled="isLoong" type="date" placeholder="选择日期" style="width: 200px;"></el-date-picker>
            <el-checkbox v-model="isLoong" style="margin-left: 5px;">长期有效</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item label="户粮">
          <el-select v-model="dtlForm.StrCityzenType" placeholder="" style="width:300px" size="small" clearable>
            <el-option v-for="(item,index) in StrCityzenTypeList" :key="index" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="籍贯" prop="StrNativePlace">
          <el-input v-model="dtlForm.StrNativePlace" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="现住地址">
          <el-input v-model="dtlForm.StrAddr" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="教育程度" prop="StrEduLv">
          <el-select v-model="dtlForm.StrEduLv" placeholder="" style="width:300px" size="small" clearable>
            <el-option v-for="(item,index) in eduList" :key="index" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="岗位" prop="InsureJob">
          <el-input v-model="dtlForm.InsureJob" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="银行卡号" prop="StrBankCard">
          <input id="upload_file2" type="file" style="display: none;" accept='image/*' name="file" @change="fileChange2($event)" />
          <el-input v-model="dtlForm.StrBankCard" style="width:300px" size="small" placeholder="请输入银行卡号或暂无">
            <el-button slot="append" title="识别图片" icon="el-icon-picture-outline" @click="distinguish('#upload_file2')" v-if="signType == 'entry'"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="开户银行" prop="StrBankName">
          <el-input v-model="dtlForm.StrBankName" style="width:300px" size="small" placeholder="请输入开户银行或暂无"></el-input>
        </el-form-item>
        <el-form-item label="紧急联系人" prop="StrContName">
          <el-input v-model="dtlForm.StrContName" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="紧急联络方式" prop="StrContTel">
          <el-input v-model="dtlForm.StrContTel" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="推荐渠道" prop="PushName">
          <el-select v-model="dtlForm.PushName" placeholder="" style="width:300px" size="small" clearable>
            <el-option v-for="(item,index) in ChannelList" :key="index" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推荐渠道备注" prop="PushRemark">
          <el-input v-model="dtlForm.PushRemark" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="推荐渠道人员来源:">
          <el-select v-model="dtlForm.ReferralChannels" size="small" placeholder="" filterable clearable style="width:300px">
            <el-option :label="item.name" :value="item.value" v-for="(item,index) in ChannelsList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否需要住宿">
          <el-radio-group v-model="dtlForm.StrIsStay">
            <el-radio label="是">是</el-radio>
            <el-radio label="否">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="是否需要工作服">
          <el-radio-group v-model="dtlForm.StrIsStay">
            <el-radio label="是">是</el-radio>
            <el-radio label="否">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="衣服尺码" :prop="needWorkClothes=='是' ? 'ClothingSizes' : ''">
          <el-select v-model="dtlForm.ClothingSizes" placeholder="" style="width:300px" size="small" clearable>
            <el-option v-for="(item,index) in sizeList" :key="index" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="鞋子尺码" :prop="needWorkClothes=='是' ? 'ShoeSize' : ''">
          <el-input v-model="dtlForm.ShoeSize" style="width:300px" size="small"></el-input>
        </el-form-item> -->
        <el-form-item label="毕业院校">
          <el-input v-model="dtlForm.AlmaMater" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="其他附件">
          <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="5" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="contractList">
            <el-button size="small" type="primary" style="margin-left: 20px;">上传</el-button>
          </el-upload>
        </el-form-item>

        <div class="workExp">工作经历</div>

        <div v-for="(item, index) in workExpList" :key="index">
          <div class="topLine" v-if="index>0"></div>
          <el-form-item label="工作单位">
            <el-input v-model="item.StrProName" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="职位/岗位">
            <el-input v-model="item.StrJobInf" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="离职原因">
            <el-input v-model="item.StrRemark" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="开始时间">
            <el-date-picker v-model="item.Strworktimestart" type="date" value-format="yyyy-MM-dd" placeholder="选择开始时间" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker v-model="item.Strworktimeend" type="date" value-format="yyyy-MM-dd" placeholder="选择开始时间" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
        </div>
        <div class="butBox flex">
          <div class="flex aic cp" style="margin-left:30px" @click="addWorkExp">
            <i class="el-icon-circle-plus icon01"></i>
            <el-button type="text" style="margin-left:5px">添加工作经历</el-button>
          </div>

          <div class="flex aic cp" style="margin-left:30px" @click="delWorkExp" v-if="workExpList.length>1">
            <i class="el-icon-delete icon02"></i>
            <el-button type="text" style="margin-left:5px">删除</el-button>
          </div>

        </div>

        <span class="footer">
          <el-button @click="close" size="small">关 闭</el-button>
          <el-popconfirm title="请确认是否继续？" @confirm="onSubmit()" style="margin-left:10px">
            <el-button type="primary" slot="reference" v-preventReClick :loading="isBtnLoading" size="small">确 认</el-button>
          </el-popconfirm>
        </span>
      </el-form>
    </div>
  </div>
</template>

<script>
  import xz from "@/common";
  import moment from 'moment';
  export default {
    props: {
      signType: {
        type: String, // 类型为 String
        required: false, // 是否必填
        default: 'entry' // 默认值
      },
    },
    data() {
      return {
        dtlForm: {
          StrExcelPath: "",
          IntExcelLine: null,
          GdUserId: "",
          StrSrvCent: "",
          StrBlCmp: "",
          StrObjName: "",
          SubProject: null,
          StrProjectType: "",
          StrObjInstName: "",
          StrUserName: "",
          IntSerialNumber: null,
          StrFileNo: "",
          StrTmpProject: null,
          StrDepName: "",
          StrJobInf: null,
          StrEmpName: "",
          StrIdCard: "",
          StrPolitical: "",
          DtIcCareEdate: null,
          StrCityzenType: "",
          StrPhoneNum: "",
          StrContName: null,
          InsureJob: '',
          StrContTel: null,
          StrNationClass: "",
          StrNativePlace: "",
          StrNativeAddr: "",
          StrAddr: "",
          StrEduLv: "",
          StrInsuranceType: "",
          DtInsuranceDate: "",
          StrMedicalCard: null,
          DtEntryBdate: "",
          StrContractType: "",
          IntContractNum: null,
          StrContractBedate: null,
          DtProbationEdate: null,
          DtContractBtime: "",
          DtContractTime: "",
          StrWorkState: "",
          DtDepartureDate: "",
          DtRealDepartureDate: "",
          StrBankCard: "",
          StrBankName: "",
          StrWithdrawal: "",
          StrInCity: "",
          StrOutsideCity: "",
          StrOther: "",
          StrPetype: "",
          StrPeres: "",
          StrEmpUsrStatus: null,
          DtInjuryBdate: null,
          StrDisabilityLevel: null,
          DtInjuryEdate: null,
          StrBlacklist: null,
          StrBlacklistReason: null,
          StrRemark: null,
          Sctjr: null,
          Gsqd: null,
          Gsqdtjr: null,
          Wbqd: null,
          Wbqdtjr: null,
          Qtqk: "",
          DtInsertDate: "",
          PushTime: "",
          PushRemark: "",
          ReferralChannels:'',
          MarriageState: "",
          IsCheckUp: "",
          OutCompanyReason: "",
          SchoolName: "",
          InSchoolTime: "",
          OutSchoolTime: "",
          ContractInfo: null,
          ThreeBeginTime: "",
          ThreeEndTime: "",
          FrontCardIdUrl: null,
          VersoCardIdUrl: null,
          BankCardUrl: null,
          ContractUrl: null,
          Extend: null,
          Json: "",
          CompanyAge: "",
          OutCompanyOptionTime: null,
          SignJob: null,
          InsureJob: null,
          ContractJson: null,
          OtherUrl: null,
          jobid: '',
          projectid: null,
          userid: Cookies.get("userid-b"),
          PushName: '',
          StrIsStay: '', //是否住宿
          StrSource: '',
          ClothingSizes: '',
          ShoeSize: '',
          AlmaMater: '',
          Dtfacetime:'',
          Source:0,//来源1杰小职  2H5 0数字化
        },
        phoneJudge: false,
        ChannelList: [
          '宁波网招',
          '社招推荐人',
          '网招中心',
          '公司渠道',
          '校招部',
          '业务项目部',
          '招聘部',
          '客服部',
          '小杰门店',
          '企业转移',
          '员工内荐',
          '供应商',
          '其他情况'
        ],
        sizeList: ['L', 'XL', 'XXL', 'XXXL', 'XXXXL', ],
        sex: '',
        birth: '',
        age: '',
        isLoong: false,
        sexList: ['男', '女'],
        eduList: ['初中及以下', '高中', '中专', '大专', '本科', '硕士', '博士'],
        ChannelsList: [{
            name: '无',
            value: 0
          },
          {
            name: '58',
            value: 1
          }, {
            name: '抖音',
            value: 2
          }, {
            name: '微信群或朋友圈',
            value: 3
          }, {
            name: '快手',
            value: 4
          }, {
            name: '小红书',
            value: 5
          }, {
            name: '其他网上招聘途径等',
            value: 6
          }, {
            name: '贴单',
            value: 7
          }, {
            name: '内荐（含熟人介绍）',
            value: 8
          }, {
            name: '设摊（含主动上门）',
            value: 9
          }, {
            name: '供应商',
            value: 10
          }, {
            name: '企业转移',
            value: 11
          }
        ],
        politicalList: ['党员', '团员', '群众', '其他'],
        StrCityzenTypeList: ['居', '农'],
        idcardJudge: false, //身份证校验
        contractList: [],
        workExpList: [{
          StrProName: '', //工作单位
          StrJobInf: '', //职位/岗位
          StrRemark: '', //离职原因
          Strworktimestart: '', //开始年月
          Strworktimeend: '', //结束年月
        }],
        dateType: '',
        index: 0,
        isBtnLoading: false,
        isdistinguish: false,
        access_token: '', //百度token
        entryRules: {
          StrEmpName: {
            required: true,
            message: '请填写姓名',
            trigger: 'blur'
          },
          StrPhoneNum: {
            required: true,
            message: '请填写手机号',
            trigger: 'blur'
          },
          StrIdCard: {
            required: true,
            message: '请填写身份证号码',
            trigger: 'blur'
          },
          StrNationClass: {
            required: true,
            message: '请填写民族',
            trigger: 'blur'
          },
          StrNativeAddr: {
            required: true,
            message: '请填写户籍地址',
            trigger: 'blur'
          },
          DtIcCareEdate: {
            required: true,
            message: '请填写身份证有效终止时间',
            trigger: 'blur'
          },
          StrEduLv: {
            required: true,
            message: '请填写教育程度',
            trigger: 'blur'
          },
          InsureJob: {
            required: true,
            message: '请填写岗位',
            trigger: 'blur'
          },
          StrBankCard: {
            required: true,
            message: '请准确填写本人银行卡',
            trigger: 'blur'
          },
          StrBankName: {
            required: true,
            message: '请输入开户银行或输入暂无',
            trigger: 'blur'
          },
          StrContName: {
            required: true,
            message: '请填写紧急联系人',
            trigger: 'blur'
          },
          StrContTel: {
            required: true,
            message: '请填写紧急联络方式',
            trigger: 'blur'
          },
          PushName: {
            required: true,
            message: '请填写推荐渠道',
            trigger: 'blur'
          },
          PushRemark: {
            required: true,
            message: '请填写推荐渠道备注',
            trigger: 'blur'
          },
          ClothingSizes: {
            required: true,
            message: '请选择衣服尺码',
            trigger: 'change'
          },
          ShoeSize: {
            required: true,
            message: '请填写鞋子尺码',
            trigger: 'blur'
          },
        }, //入职表单验证
        resProjectList: [],
        searPostList: [],
        InterViewrules: {
          StrEmpName: {
            required: true,
            message: '请填写姓名',
            trigger: 'blur'
          },
          Dtfacetime:{
            required: true,
            message: '请选择面试时间',
            trigger: 'change'
          },
          StrEduLv: {
            required: true,
            message: '请填写教育程度',
            trigger: 'blur'
          },
          StrPhoneNum: {
            required: true,
            message: '请填写手机号',
            trigger: 'blur'
          },
          StrNationClass: {
            required: true,
            message: '请填写民族',
            trigger: 'blur'
          },
          StrNativePlace: {
            required: true,
            message: '请填写籍贯',
            trigger: 'blur'
          },
          PushName: {
            required: true,
            message: '请填写推荐渠道',
            trigger: 'blur'
          },
          PushRemark: {
            required: true,
            message: '请填写推荐渠道备注',
            trigger: 'blur'
          },
        },
      };
    },
    async created() {
      if (this.signType == 'entry') {
        this.getBaiduToken();
        this.dtlForm.StrSource = '待入职登记'
      } else {
        this.dtlForm.StrSource = '待面试登记'
      }
      this.getProList();
    },
    methods: {
      //获取百度token
      getBaiduToken() {
        const apiKey = 'xqu5grmIGRuLg9GS1z8TDhWF';
        // Secret Key
        const seckey = '3k4EUH7e27STG1ZPOvY9LMrFBVkihsGx';
        const tokenUrl = `/oauth/2.0/token?grant_type=client_credentials&client_id=${apiKey}&client_secret=${seckey}`;
        xz.getBaiduToken(tokenUrl).then(res => {
          try {
            this.access_token = res.data.access_token;
          } catch (e) {
            this.access_token = '';
          }
        })
      },
      //获取项目
      getProList() {
        xz.getresourcechangejoblist({}, localStorage.loginRoletype).then(res => {
          if (res.status == 'ok') {
            // 项目列表去重
            let obj = {};
            let peon = res.data.retList.reduce((cur, next) => {
              obj[next.StrprojectName] ? "" : obj[next.StrprojectName] = true && cur.push(next);
              return cur;
            }, []) //设置cur默认类型为数组，并且初始值为空的数组
            // 岗位列表去重
            this.resProjectList = peon
          }
        })
      },
      changePro(val) {
        console.log(val)
        xz.getresourcejobcustomerlist(localStorage.loginRoletype, {
          projectid: val
        }).then(res => {
          this.searPostList = res.data;
        })
      },
      reset() {
        this.dtlForm = this.$options.data.call(this).dtlForm;
      },
      //调用相册&相机识别
      distinguish(name) {
        $(name).click();
      },
      fileChange(el) {
        let file = $("#upload_file").get(0).files[0];
        console.log(file)
        let formData2 = new FormData();
        formData2.append("action", "save");
        formData2.append("pagename", "entimg");
        formData2.append("userid", Cookies.get("userid-b"));
        formData2.append("entid", Cookies.get("userid-b"));
        formData2.append("entPicFile", file, file.name);
        xz.uploadCert(formData2).then((res) => {
          if (res) {
            this.dtlForm.FrontCardIdUrl = res;
            this.isdistinguish = true;
            let url = '/rest/2.0/ocr/v1/idcard?access_token=' + this.access_token;
            let param = "id_card_side=" + "front" + "&url=" + this.$store.state.EMP.imgPath + res;
            xz.baiduOCR(url, param).then((r) => {
              try {
                this.$message.success('识别成功，请核对');
                this.isdistinguish = false;
                this.dtlForm.StrEmpName = r.data.words_result.姓名.words;
                this.dtlForm.StrIdCard = r.data.words_result.公民身份号码.words;
                this.dtlForm.StrNativeAddr = r.data.words_result.住址.words;
                this.idcardJudge = true;
                this.dtlForm.StrNationClass = r.data.words_result.民族.words;
                this.getBirth()
              } catch (e) {
                this.isdistinguish = false;
                this.$message.error('识别失败！');
              }
            })
          }
        })
      },
      checkPhone(val) {
        const regex = /^1[3-9]\d{9}$/;
        if (!regex.test(val)) {
          this.phoneJudge = false;
          this.$message.error('请填写正确的手机号码')
        } else {
          this.phoneJudge = true;
        }
      },
      // 身份证校验
      checkIdcard() {
        let val = this.dtlForm.StrIdCard;
        if (val.length == 0) {
          this.idcardJudge = false;
        } else if (val.length != 18) {
          this.idcardJudge = false;
          this.$message.error('身份证格式不正确')
        } else {
          const idcode = val;
          const weight_factor = [
            7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2,
          ];
          const check_code = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
          const code = idcode + "";
          const last = idcode[17].toUpperCase(); // 最后一个
          const seventeen = code.substring(0, 17);
          // ISO 7064:1983.MOD 11-2
          // 判断最后一位校验码是否正确
          const arr = seventeen.split("");
          const len = arr.length;
          let num = 0;
          for (let i = 0; i < len; i++) {
            num = num + arr[i] * weight_factor[i];
          }
          // 获取余数
          var resisue = num % 11;
          var last_no = check_code[resisue];
          // 格式的正则
          // 正则思路
          var idcard_patter =
            /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
          // 判断格式是否正确
          var format = idcard_patter.test(idcode);
          console.log(last === last_no && format == true)
          if (last === last_no && format == true) {
            this.idcardJudge = true;
            this.getBirth()
          } else {
            this.idcardJudge = false;
            this.$message.error('身份证格式不正确')
          }
        }
      },
      //计算生日 年龄 性别
      getBirth() {
        if (this.dtlForm.StrIdCard != undefined && this.dtlForm.StrIdCard) {
          let idCard = this.dtlForm.StrIdCard
          let age;
          let sexnum = null;
          let sex = null;
          let myDate = new Date();
          let month = myDate.getMonth() + 1;
          var day = myDate.getDate();
          sexnum = idCard.substring(16, 17);
          if (sexnum % 2 === 0) {
            sex = "女";
          } else {
            sex = "男";
          }
          age = myDate.getFullYear() - idCard.substring(6, 10) - 1;
          if (
            idCard.substring(10, 12) < month ||
            (idCard.substring(10, 12) == month && idCard.substring(12, 14) <= day)
          )
            age++;
          var birth = idCard.substring(6, 10) + "-" + idCard.substring(10, 12);
          this.age = age;
          this.birth = birth;
          this.sex = sex;
        }
      },
      fileChange2() {
        let file = $("#upload_file2").get(0).files[0];
        let formData2 = new FormData();
        formData2.append("action", "save");
        formData2.append("pagename", "entimg");
        formData2.append("userid", Cookies.get("userid-b"));
        formData2.append("entid", Cookies.get("userid-b"));
        formData2.append("entPicFile", file, file.name);
        xz.uploadCert(formData2).then((res) => {
          if (res) {
            this.dtlForm.BankCardUrl = res;
            this.isdistinguish = true;
            let url = '/rest/2.0/ocr/v1/bankcard?access_token=' + this.access_token;
            let param = "url=" + this.$store.state.EMP.imgPath + res;
            xz.baiduOCR(url, param).then((r) => {
              try {
                this.$message.success('识别成功，请核对');
                this.isdistinguish = false;
                this.dtlForm.StrBankName = r.data.result.bank_name;
                this.dtlForm.StrBankCard = r.data.result.bank_card_number;
              } catch (e) {
                this.isdistinguish = false;
                this.$message.error('识别失败！');
              }
            })
          }
        })
      },
      fileChange3() {
        let file = $("#upload_file3").get(0).files[0];
        let formData2 = new FormData();
        formData2.append("action", "save");
        formData2.append("pagename", "entimg");
        formData2.append("userid", Cookies.get("userid-b"));
        formData2.append("entid", Cookies.get("userid-b"));
        formData2.append("entPicFile", file, file.name);
        xz.uploadCert(formData2).then((res) => {
          if (res) {
            this.dtlForm.VersoCardIdUrl = res;
            this.isdistinguish = true;
            let url = '/rest/2.0/ocr/v1/idcard?access_token=' + this.access_token;
            let param = "id_card_side=" + "back" + "&url=" + this.$store.state.EMP.imgPath + res;
            xz.baiduOCR(url, param).then((r) => {
              try {
                this.$message.success('识别成功，请核对');
                this.isdistinguish = false;
                this.dtlForm.DtIcCareEdate = moment(r.data.words_result.失效日期.words).format('YYYY-MM-DD');
              } catch (e) {
                this.isdistinguish = false;
                this.$message.error('识别失败！');
              }
            })
          }
        })
      },
      // 上传附件
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "docinf");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            let d = {
              uid: '',
              url: this.docHead + res,
              name: file.name
            }
            this.contractList.push(d)
            // this.fileList = this.itemInfo.fileUrl
          } else {
            // this.dtlForm.OtherUrl = ''
          }
        });
      },
      // 删除附件
      handleFileRemove(file) {
        this.contractList.forEach((e, i) => {
          if (file.uid == e.uid) {
            this.contractList.splice(i, 1)
          }
        });
        console.log(this.contractList);
      },
      handleExceed() {
        this.$message.error(`当前限制最多上传 5 个文件`);
      },
      addWorkExp() {
        let d = {
          StrProName: '', //工作单位
          StrJobInf: '', //职位/岗位
          StrRemark: '', //离职原因
          Strworktimestart: '', //开始年月
          Strworktimeend: '', //结束年月
        }
        this.workExpList.push(d)
      },
      delWorkExp() {
        this.workExpList.splice(this.workExpList.length - 1, 1)
      },
      onSubmit() {
        if (this.signType != 'entry') {
          this.idcardJudge = true;
        }
        if (this.isLoong) {
          this.dtlForm.DtIcCareEdate = '2999-12-31'
        }
        if (this.dtlForm.StrIdCard && this.dtlForm.StrIdCard.includes('x')) {
          this.dtlForm.StrIdCard = val = val.replace(/x/g, 'X');
        }
        this.$refs["signForm"].validate((valid) => {
          if (valid) {
            if (this.dtlForm.StrPhoneNum.length != 11) {
              this.$message.error('请输入正确的手机号');
            } else if (this.dtlForm.StrPhoneNum == this.dtlForm.StrContTel) {
              this.$message.error('手机号不能与紧急联系人手机号相同');
            } else if (this.idcardJudge && this.phoneJudge) {
              if (!this.isBtnLoading) {
                this.isBtnLoading = true;
                if (this.contractList.length > 0) {
                  let d = JSON.parse(JSON.stringify(this.contractList))
                  this.dtlForm.OtherUrl = JSON.stringify(d)
                }
                if (!this.dtlForm.jobid) {
                  this.dtlForm.jobid = '00000000-0000-0000-0000-111111111111'
                }
                const formData = new FormData();
                formData.append("strjson", JSON.stringify(this.dtlForm));
                formData.append("strwork", JSON.stringify(this.workExpList));
                console.log(formData)
                xz.H5ProjectOption(formData, this.signType == 'entry' ? 'H5ProjectOptionnew' : 'H5ProjectOptionDms').then((res) => {
                  if (res.status == "ok") {
                    this.isBtnLoading = false;
                    this.$message({
                      duration: 5000,
                      type: "success",
                      message: "保存成功"
                    });
                    this.isSuccess = true;
                    this.close();
                  } else {
                    setTimeout(() => {
                      this.isBtnLoading = false;
                    }, 1000);
                    this.$message.error(res.msg);
                  }
                });
              }
            } else {
              if (!this.idcardJudge) {
                this.$message.error('请输入正确的身份证');
              }
              if (!this.phoneJudge) {
                this.$message.error('请输入正确的手机号');
              }
            }
          }
        })
      },
      close() {
        this.$emit('close')
      },
    },
  };
</script>
<style scoped>
  .eleTltle {
    font-weight: 600;
    font-size: 17px;
    text-transform: capitalize;
    width: 100%;
    height: 56px;
    line-height: 56px;
    background: #fff;
    text-align: center;
  }

  .eleForm {
    padding: 20px 0;
  }

  .workExp {
    font-weight: 600;
    font-size: 16px;
    padding-left: 5px;
    margin: 10px 5px;
    padding-top: 10px;
    border-top: 1px solid #ccc;
  }

  .topLine {
    border-top: 1px solid #ccc;
    margin-bottom: 10px;
  }

  .icon01 {
    color: #19bd92;
    font-size: 20px;
    cursor: pointer;
  }

  .icon02 {
    color: #F56C6C;
    font-size: 20px;
    cursor: pointer;
  }

  .footer {
    display: flex;
    justify-content: end;
    padding-right: 20px;
  }

  .butBox {
    padding-left: 30px
  }
</style>
<style>
  .page_entrySign .el-icon-picture-outline {
    font-size: 18px;
  }

  .page_entrySign .el-input-group__append,
  .page_entrySign .el-input-group__prepend {
    padding: 0 10px;
  }
</style>